import React from 'react';

import { Tooltip } from 'e100-react-components';

import { useMediaQuery } from 'common/hooks';

import { makeStyles } from 'e100-react-components';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-block',
    maxWidth: '100%',

    '& > div': {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    }
  },
}));

export const DataGridTooltipCell = ({
  rowData,
  name
}: DataGridTooltipCellProps) => {
  const classes = useStyles();
  const { isMobile, isTablet } = useMediaQuery();
  const value = rowData[name];

  return (
    <div className={isMobile || isTablet ? '' : classes.root}>
      <Tooltip
        title={value}
        enterDelay={1000}
        enterNextDelay={1000}
        enterTouchDelay={0}
      >
        <>{value}</>
      </Tooltip>
    </div>
  );
};

interface DataGridTooltipCellProps {
  rowData: Record<string, string>;
  name: string;
}
